const obsolete = Symbol('dashboard-obsolete');

// A refresh never owns a saved mutation: failed or obsolete reads resolve false.
export function createPublicBookingDashboardLoader({
  request,
  onData,
  onLoading,
  onError,
  timeoutMs = 25000,
}) {
  if (typeof request !== 'function' || typeof onData !== 'function') {
    throw new TypeError('request e onData sono obbligatori.');
  }
  const deadline = Number.isFinite(timeoutMs) && timeoutMs > 0
    ? Math.max(1, Math.floor(timeoutMs)) : 25000;
  let current = null;
  let disposed = false;

  const notify = (callback, value) => {
    if (typeof callback !== 'function') return;
    try {
      callback(value);
    } catch (error) {
      console.error('Errore aggiornamento elenco prenotazioni:', error);
    }
  };

  const refresh = ({ force = false } = {}) => {
    if (disposed) return Promise.resolve(false);
    if (current && !force) return current.promise;
    if (current) {
      const previous = current;
      current = null;
      previous.cancel();
    }

    const controller = new AbortController();
    const job = { controller, timer: null, promise: null, cancel: null };
    const isCurrent = () => !disposed && current === job;
    const cancellation = new Promise((resolve) => {
      job.cancel = () => {
        clearTimeout(job.timer);
        resolve(obsolete);
        controller.abort();
      };
    });
    const timeout = new Promise((resolve, reject) => {
      job.timer = setTimeout(() => {
        reject(Object.assign(new Error('Tempo di attesa del caricamento prenotazioni superato.'), {
          code: 'dashboard-timeout',
        }));
        controller.abort();
      }, deadline);
    });
    current = job;
    // Race the entire request, including token retrieval and JSON decoding.
    // Promise.race also handles any rejection arriving after cancellation.
    const pending = Promise.resolve().then(() => (isCurrent()
      ? request({ signal: controller.signal }) : obsolete));
    job.promise = Promise.race([pending, cancellation, timeout]).then((data) => {
      if (!isCurrent() || data === obsolete) return false;
      onData(data);
      return true;
    }).catch((error) => {
      if (isCurrent()) notify(onError, error);
      return false;
    }).finally(() => {
      clearTimeout(job.timer);
      if (isCurrent()) {
        current = null;
        notify(onLoading, false);
      }
    });
    notify(onLoading, true);
    return job.promise;
  };

  const dispose = () => {
    if (disposed) return;
    disposed = true;
    const previous = current;
    current = null;
    if (previous) previous.cancel();
  };

  return { refresh, dispose };
}
